import React from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../molecules/FlexRow'
import OpalHeading from '../../../../opal/OpalHeading'
import AIEnabledTag from '../shared/AIEnabledTag'
import DeprecatedTag from '../shared/DeprecatedTag'

function DatasourceHeader ({ datasource }) {
  return (
    <div>
      <FlexRow className='gap-md'>
        <OpalHeading className='font-size-lg'>{datasource.displayName}</OpalHeading>
        {datasource.isAiEnabled ? (
          <AIEnabledTag />
        ) : null}
        {datasource.isDeprecated ? (
          <DeprecatedTag />
        ) : null}
      </FlexRow>
      <FlexRow>
        <OpalHeading className='font-size-xs'>{datasource.code}</OpalHeading>
      </FlexRow>
    </div>
  )
}

DatasourceHeader.propTypes = {
  datasource: PropTypes.shape({
    displayName: PropTypes.string,
    code: PropTypes.string,
    isAiEnabled: PropTypes.bool,
    isDeprecated: PropTypes.bool
  })
}

export default DatasourceHeader
